'use strict';

const STEEL_OPTIONS = {
      'SSAB': {
        gauges: ['0.5mm / approx. 25GA'],
        coatings: ['Pural'],
        finishes: ['Standard'],
        colors: ['RR33', 'RR32', 'RR23', 'RR2H3', 'RR887']
      },
      'Cascadia Metals LTD': {
        gauges: ['26GA', '24GA'],
        coatings: ['SMP', 'SMP Textured', 'PVDF', 'Printed SMP', 'Printed PVDF'],
        finishes: ['Glossy', 'Textured', 'Printed'],
        colors: ['Black']
      },
      'Ideal Roofing': {
        gauges: ['26GA', '24GA'],
        coatings: ['PVDF', 'SMP'],
        finishes: ['Textured', 'Glossy'],
        colors: ['Black', 'Charcoal', 'Dark Brown', 'White', 'Custom']
      },
      'Agway': {
        gauges: ['26GA', '24GA'],
        coatings: ['PVDF', 'SMP'],
        finishes: ['Textured', 'Glossy'],
        colors: ['Black', 'Charcoal', 'Dark Brown', 'White', 'Custom']
      },
      'Color Steel': {
        gauges: ['26GA', '24GA'],
        coatings: ['PVDF', 'SMP'],
        finishes: ['Textured', 'Glossy'],
        colors: ['Black', 'Charcoal', 'Dark Brown', 'White', 'Custom']
      }
    };

    const CASCADIA_COLOR_CATALOG = {
      "SMP": {
            "finish": "Glossy",
            "colors": [
                  {
                        "name": "Antique Linen",
                        "filename": "antique-linen-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/antique-linen-400x199.png?v=1779406598"
                  },
                  {
                        "name": "Appliance White",
                        "filename": "appliance-white-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/appliance-white-400x199.png?v=1779406622"
                  },
                  {
                        "name": "Black",
                        "filename": "black-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/black-400x199_ce371a04-4b32-4f58-87e5-c80a9c1278d0.png?v=1779406339"
                  },
                  {
                        "name": "Bone White",
                        "filename": "bone-white-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/bone-white-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Briarwood Tan",
                        "filename": "briarwood-tan-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/briarwood-tan-400x199.png?v=1779406765"
                  },
                  {
                        "name": "Bright Red",
                        "filename": "bright-red-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/bright-red-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Bright White",
                        "filename": "bright-white-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/bright-white-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Buckskin",
                        "filename": "Buckskin-2-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Buckskin-2-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Burgundy",
                        "filename": "burgundy-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/burgundy-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Cambridge White",
                        "filename": "cambridge-white-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/cambridge-white-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Cashmere",
                        "filename": "cashmere-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/cashmere-400x199.png?v=1779406765"
                  },
                  {
                        "name": "Charcoal",
                        "filename": "charcoal-1-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/charcoal-1-400x199_f76b46b4-fb70-466a-9b70-09aaa53df217.png?v=1779406764"
                  },
                  {
                        "name": "Coffee Brown",
                        "filename": "coffee-brown-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/coffee-brown-400x199_f82cf483-8a36-43a7-9640-da5ad3ebb1db.png?v=1779406764"
                  },
                  {
                        "name": "Dark Brown",
                        "filename": "dark-brown-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/dark-brown-400x199.png?v=1779406765"
                  },
                  {
                        "name": "Dark Graphite",
                        "filename": "Dark-Graphite-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Dark-Graphite-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Dark Green",
                        "filename": "DARK-GREEN-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/DARK-GREEN-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Dark Red",
                        "filename": "dark-red-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/dark-red-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Deep Water Green",
                        "filename": "deep-water-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/deep-water-green-400x199.png?v=1779406765"
                  },
                  {
                        "name": "Forest Green",
                        "filename": "forest-green-1-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/forest-green-1-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Gold",
                        "filename": "gold-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/gold-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Heron Blue",
                        "filename": "heron-blue-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/heron-blue-400x199.png?v=1779406764"
                  },
                  {
                        "name": "Iron Ore",
                        "filename": "iron-ore-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/iron-ore-400x199.png?v=1775084376"
                  },
                  {
                        "name": "Labrador Blue",
                        "filename": "labrador-blue-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/labrador-blue-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Melchers Green",
                        "filename": "melchers-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/melchers-green-400x199.png?v=1775084376"
                  },
                  {
                        "name": "Metro Brown",
                        "filename": "metro-brown-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/metro-brown-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Mist Green",
                        "filename": "mist-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/mist-green-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Pacific Turquoise",
                        "filename": "pacific-turquoise-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/pacific-turquoise-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Pebblestone",
                        "filename": "pebblestone-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/pebblestone-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Polar White",
                        "filename": "polar-white-1-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/polar-white-1-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Regent Grey",
                        "filename": "regent-grey-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/regent-grey-400x199.png?v=1779407034"
                  },
                  {
                        "name": "Royal Blue",
                        "filename": "royal-blue-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/royal-blue-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Sage Green",
                        "filename": "sage-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/sage-green-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Sapphire Blue",
                        "filename": "sapphire-blue-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/sapphire-blue-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Slate Blue",
                        "filename": "slate-blue-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/slate-blue-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Spruce Green",
                        "filename": "spruce-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/spruce-green-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Stone Grey",
                        "filename": "stone-grey-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/stone-grey-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Surf White",
                        "filename": "surf-white-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/surf-white-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Tan",
                        "filename": "Tan-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Tan-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Tile Red",
                        "filename": "tile-red-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/tile-red-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Turquoise",
                        "filename": "turquoise-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/turquoise-400x199.png?v=1779407033"
                  },
                  {
                        "name": "White White",
                        "filename": "white-white-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/white-white-400x199.png?v=1779407033"
                  },
                  {
                        "name": "Wicker",
                        "filename": "wicker-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/wicker-400x199.png?v=1779407033"
                  }
            ]
      },
      "SMP Textured": {
            "finish": "Textured",
            "colors": [
                  {
                        "name": "Burnished Slate",
                        "filename": "Burnished-Slate-1.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Burnished-Slate-1.png?v=1779407169"
                  },
                  {
                        "name": "Dark Graphite",
                        "filename": "Dark-Graphite.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Dark-Graphite.png?v=1775084376"
                  },
                  {
                        "name": "Graphite",
                        "filename": "Graphite.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Graphite.png?v=1779407169"
                  },
                  {
                        "name": "Kona Brown",
                        "filename": "Kona-brown.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Kona-brown.png?v=1779407169"
                  },
                  {
                        "name": "Onyx Black",
                        "filename": "Onyx-Black.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Onyx-Black.png?v=1775084376"
                  },
                  {
                        "name": "Sepia Brown",
                        "filename": "Sepia-brown.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Sepia-brown.png?v=1779407169"
                  }
            ]
      },
      "PVDF": {
            "finish": "Glossy",
            "colors": [
                  {
                        "name": "Black",
                        "filename": "black-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/black-400x199_ce371a04-4b32-4f58-87e5-c80a9c1278d0.png?v=1779406339"
                  },
                  {
                        "name": "Bronze",
                        "filename": "bronze-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/bronze-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Champagne Metallic",
                        "filename": "CHAMPAGNE-METALLIC-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/CHAMPAGNE-METALLIC-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Colonial Red",
                        "filename": "colonial-red-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/colonial-red-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Copper Penny",
                        "filename": "copper-penny-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/copper-penny-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Dark Bronze",
                        "filename": "dark-bronze-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/dark-bronze-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Forest Green",
                        "filename": "forest-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/forest-green-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Hartford Green",
                        "filename": "hartford-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/hartford-green-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Hemlock Green",
                        "filename": "hemlock-green-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/hemlock-green-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Mocha",
                        "filename": "MOCHA-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/MOCHA-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Old Town Grey",
                        "filename": "old-town-grey-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/old-town-grey-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Old Zinc Grey",
                        "filename": "old-zinc-grey-1-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/old-zinc-grey-1-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Parchment",
                        "filename": "PARCHMENT-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/PARCHMENT-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Regal Blue",
                        "filename": "regal-blue-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/regal-blue-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Regal White",
                        "filename": "REGAL-WHITE-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/REGAL-WHITE-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Retro Red",
                        "filename": "retro-red-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/retro-red-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Sierra Tan",
                        "filename": "SIERRA-TAN-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/SIERRA-TAN-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Silver Metallic",
                        "filename": "silver-metallic-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/silver-metallic-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Slate Grey",
                        "filename": "slate-grey-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/slate-grey-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Terra Cotta",
                        "filename": "terra-cotta-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/terra-cotta-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Twilight Blue",
                        "filename": "twilight-blue-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/twilight-blue-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Weathered Copper",
                        "filename": "weathered-copper-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/weathered-copper-400x199.png?v=1779406339"
                  },
                  {
                        "name": "Weathered Zinc",
                        "filename": "weathered-zinc-1-400x199.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/weathered-zinc-1-400x199.png?v=1779406339"
                  }
            ]
      },
      "Printed SMP": {
            "finish": "Printed",
            "colors": [
                  {
                        "name": "Ash Wood",
                        "filename": "ASH-WOOD-600x600.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/ASH-WOOD-600x600.jpg?v=1779406206"
                  },
                  {
                        "name": "Concrete",
                        "filename": "CONCRETE.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/CONCRETE.png?v=1779406212"
                  },
                  {
                        "name": "Corten",
                        "filename": "CORTEN-14.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/CORTEN-14.png?v=1779406213"
                  },
                  {
                        "name": "Heritage",
                        "filename": "HERITAGE.png",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/HERITAGE.png?v=1779406209"
                  },
                  {
                        "name": "Knotty Pine",
                        "filename": "KNOTTY-PINE-600x600.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/KNOTTY-PINE-600x600.jpg?v=1779406206"
                  },
                  {
                        "name": "Light Pine",
                        "filename": "Light-pine-600x600.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Light-pine-600x600.jpg?v=1779406206"
                  },
                  {
                        "name": "Mesquite",
                        "filename": "MESQUITE-600x600.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/MESQUITE-600x600.jpg?v=1779406207"
                  }
            ]
      },
      "Printed PVDF": {
            "finish": "Printed",
            "colors": [
                  {
                        "name": "Acorn",
                        "filename": "Acorn-H-Wood-D-Orange.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Acorn-H-Wood-D-Orange.jpg?v=1779406050"
                  },
                  {
                        "name": "Aged Copper",
                        "filename": "Aged-Copper-Trail-600x407.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Aged-Copper-Trail-600x407.jpg?v=1779406049"
                  },
                  {
                        "name": "Autumn",
                        "filename": "Autumn-Water-Ash-Fir-scaled.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Autumn-Water-Ash-Fir-scaled.jpg?v=1779406051"
                  },
                  {
                        "name": "Barnboard",
                        "filename": "Barnboard-Noche-Gray-scaled.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Barnboard-Noche-Gray-scaled.jpg?v=1779406050"
                  },
                  {
                        "name": "Birch",
                        "filename": "Birch-Red-Oak-White-600x393.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Birch-Red-Oak-White-600x393.jpg?v=1779406049"
                  },
                  {
                        "name": "Canyon",
                        "filename": "Canyon-Conifer-White.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Canyon-Conifer-White.jpg?v=1779406050"
                  },
                  {
                        "name": "Dark Zinc",
                        "filename": "Dark-Zinc-R.Zinc-Dark-600x456.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Dark-Zinc-R.Zinc-Dark-600x456.jpg?v=1779406049"
                  },
                  {
                        "name": "Durango",
                        "filename": "Durango-Naive-Burnt-600x460.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Durango-Naive-Burnt-600x460.jpg?v=1779406048"
                  },
                  {
                        "name": "Espresso",
                        "filename": "Espresso-Table-Walnut-600x456.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Espresso-Table-Walnut-600x456.jpg?v=1779406049"
                  },
                  {
                        "name": "Frontier",
                        "filename": "Frontier-Naive-600x461.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Frontier-Naive-600x461.jpg?v=1779406049"
                  },
                  {
                        "name": "Gunstock",
                        "filename": "Gunstock-Dark-Cherry-600x453.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Gunstock-Dark-Cherry-600x453.jpg?v=1779406049"
                  },
                  {
                        "name": "Homestead",
                        "filename": "Homestead-Golden-Oak-Dark-600x464.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Homestead-Golden-Oak-Dark-600x464.jpg?v=1779406049"
                  },
                  {
                        "name": "Light Zinc",
                        "filename": "Light-Zinc-Real-Zinc-Light-600x460.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Light-Zinc-Real-Zinc-Light-600x460.jpg?v=1779406050"
                  },
                  {
                        "name": "Ponderosa",
                        "filename": "Ponderosa-Noche-Caramel-scaled.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Ponderosa-Noche-Caramel-scaled.jpg?v=1779406050"
                  },
                  {
                        "name": "Rustic Red",
                        "filename": "Rustic-Red-Korten-600x456.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Rustic-Red-Korten-600x456.jpg?v=1779406049"
                  },
                  {
                        "name": "Saddle",
                        "filename": "Saddle-Cordoba-Cherry-600x452.jpg",
                        "image": "https://cdn.shopify.com/s/files/1/0983/0495/0568/files/Saddle-Cordoba-Cherry-600x452.jpg?v=1779406049"
                  }
            ]
      }
};
    
    
    const METAL_TILE_OPTIONS = {
      'Vietnam - budget friendly option': {
        gauges: ['28GA'],
        coatings: ['Polyester'],
        finishes: ['Textured'],
        colors: ['Black', 'Charcoal', 'Dark Brown', 'White', 'Custom'],
        styles: ['Monterrey (28 sq.ft. - 6 modules)']
      },
      'Germany - mid-range European option': {
        gauges: ['26GA'],
        coatings: ['Semi-modified Polyester'],
        finishes: ['Textured'],
        colors: ['Black', 'Charcoal', 'Dark Brown', 'White', 'Custom'],
        styles: ['Monterrey (28 sq.ft. - 6 modules)']
      },
      'Finland - premium quality world-market leader': {
        gauges: ['0.5mm (approx. 25GA)'],
        coatings: ['GreenCoat Pural BT'],
        finishes: ['Textured'],
        colors: ['Black', 'Charcoal', 'Dark Brown', 'White', 'Custom'],
        styles: ['Monterrey (28 sq.ft. - 6 modules)', 'Adamante (28 sq.ft. - 6 modules)']
      }
    };

    const MEMBRANE_PRICES = {
      standing_seam: {
        psu30ht: { coverage: 200, standard: 135, skid: 135, skidThreshold: 25 },
        drainageMat: { coverage: 360, standard: 360, bulk: 360, bulkThreshold: 10 }
      },
      metal_tiles: {
        ruukki170: { coverage: 800, price: 180 },
        synthetic135: { coverage: 800, price: 135 }
      }
    };

    const ACCESSORY_PRICES = {
      screws250: 20,
      clipsMechanical: 0.30,
      clipsMechanicalBox1000: 300,
      clipsSnapLock: 0.50,
      clipsSnapLockBox250: 125,
      vilpeVent: 120,
      masterFlashing: { standard: 20, bulk: 15, bulkThreshold: 50 },
      bathroomVent: { standard: 35, bulk: 30, bulkThreshold: 50 },
      snowRetention: {
        colorGardRail: 57.5,
        splice: 2.5,
        snowClipII: 6.5,
        versaClip: 5,
        s5eClamp: 13,
        s5sClamp: 15,
        s5nClamp: 16,
        colourStrip: 12,
        everyOtherSeamLF: 23,
        everySeamLF: 30
      }
    };

    const METAL_TILE_PRICING = {
      'Vietnam - budget friendly option': {
        panels: {
          'Monterrey (28 sq.ft. - 6 modules)': 35
        },
        trims: {
          starter: 18,
          valleys: 32,
          gable: 23,
          ridge: 28,
          wall: 18,
          snowHolder: 17
        }
      },
      'Germany - mid-range European option': {
        panels: {
          'Monterrey (28 sq.ft. - 6 modules)': 40
        },
        trims: {
          starter: 20,
          valleys: 35,
          gable: 25,
          ridge: 30,
          wall: 20,
          snowHolder: 20
        }
      },
      'Finland - premium quality world-market leader': {
        panels: {
          'Monterrey (28 sq.ft. - 6 modules)': 62.5,
          'Adamante (28 sq.ft. - 6 modules)': 65
        },
        trims: {
          starter: 30,
          valleys: 55,
          gable: 30,
          ridge: 35,
          wall: 30,
          snowHolder: 6
        }
      }
    };

    const METAL_TILE_ACCESSORY_PRICES = {
      membrane125: { name: 'Membrane 125 (800 SF)', coverage: 800, cost: 120 },
      membrane170: { name: 'Membrane 170 (800 SF)', coverage: 800, cost: 170 },
      multipurposeClosure: { name: 'Multipurpose Closure Strip', coverageInches: 39, cost: 1.95 },
      screws250: 20,
      vmaxTowerVent: 135,
      ridgeVentTape: 18,
      strapping: 3
    };

    const STANDING_SEAM_TRIM_PRICES = {
      '26GA_SMP_Glossy': {
        eave: 20, j: 19, perforatedJ: 32, step: 30, ridge5: 25, ridge6: 28, valley: 35, valleyCleat: 15, valleySlock: 39
      },
      '26GA_SMP_Textured': {
        eave: 21, j: 19, perforatedJ: 33, step: 32, ridge5: 26, ridge6: 29, valley: 37, valleyCleat: 15, valleySlock: 41
      },
      '24GA_SMP_Glossy': {
        eave: 22, j: 20, perforatedJ: 34, step: 34, ridge5: 28, ridge6: 30, valley: 39, valleyCleat: 16, valleySlock: 43
      },
      '24GA_SMP_Textured': {
        eave: 23, j: 21, perforatedJ: 35, step: 35, ridge5: 29, ridge6: 32, valley: 41, valleyCleat: 16, valleySlock: 45
      },
      'PVDF': {
        eave: 24, j: 22, perforatedJ: 37, step: 39, ridge5: 31, ridge6: 35, valley: 45, valleyCleat: 17, valleySlock: 49
      },
      'Pural': {
        eave: 25, j: 23, perforatedJ: 38, step: 40, ridge5: 32, ridge6: 36, valley: 46, valleyCleat: 18, valleySlock: 50
      }
    };

    const STANDING_SEAM_PANEL_PRICES = [
      { manufacturer: 'standard', coating: 'SMP', finish: 'Glossy', gauge: '26GA', price: 3.35, label: 'SMP - 26 GA' },
      { manufacturer: 'standard', coating: 'SMP', finish: 'Textured', gauge: '26GA', price: 3.50, label: 'SMP Textured - 26 GA' },
      { manufacturer: 'standard', coating: 'SMP', finish: 'Glossy', gauge: '24GA', price: 3.85, label: 'SMP - 24 GA' },
      { manufacturer: 'standard', coating: 'SMP', finish: 'Textured', gauge: '24GA', price: 4.00, label: 'SMP Textured - 24 GA' },
      { manufacturer: 'standard', coating: 'PVDF', finish: 'any', gauge: '24GA', price: 4.30, label: 'PVDF - 24 GA' },
      { manufacturer: 'SSAB', coating: 'Pural', finish: 'Standard', gauge: '0.5mm / approx. 25GA', price: 4.50, label: 'SSAB GreenCoat Pural - 25 GA' }
    ];

    const PRODUCT_CATALOG = [
      { sku:'1', uuid:'e7e26415-d47e-462d-b582-15f19b2e14b8', name:'Parapet Capping', measurement:'PARAPET_LENGTH', coverage:10, unit:'Each', cost:40, itemType:'material', system:'both' },
      { sku:'2', uuid:'632a720f-80ea-4fa1-999f-2d3095bb9df8', name:'Strapping 1x3x12', measurement:'TOTAL_PITCH_AREA', coverage:14, unit:'EA', cost:3, itemType:'material', system:'metal_tiles' },
      { sku:'3', uuid:'364688c1-8378-4934-ad42-1b9d5bc48e8f', name:'Drainage Mat (360 SF roll)', measurement:'TOTAL_PITCH_AREA', coverage:360, unit:'Roll', cost:360, itemType:'material', system:'standing_seam' },
      { sku:'34', uuid:'34-master-flashing-auto', name:'Master Flashing', measurement:'TOTAL_PITCH_AREA', coverage:500, unit:'Each', cost:20, itemType:'material', system:'both' },
      { sku:'35', uuid:'35-bathroom-metal-vent-auto', name:'Bathroom Metal Vent', measurement:'TOTAL_PITCH_AREA', coverage:1000, unit:'Each', cost:35, itemType:'material', system:'both' },
      { sku:'36', uuid:'36-delivery', name:'Delivery', measurement:'DELIVERY', coverage:1, unit:'Service', cost:300, itemType:'material', system:'both' },
      { sku:'37', uuid:'37-flat-roof-base', name:'Base', measurement:'TOTAL_FLAT_AREA', coverage:86, unit:'Roll', cost:95, itemType:'material', system:'both' },
      { sku:'38', uuid:'38-flat-roof-cap', name:'Cap', measurement:'TOTAL_FLAT_AREA', coverage:72, unit:'Roll', cost:89, itemType:'material', system:'both' },
      { sku:'4', uuid:'dabf306f-7188-45b7-9db9-3fafff0a91d1', name:'S-5! Colorgard snow guards', measurement:'EAVES_LENGTH', coverage:1, unit:'Linear Foot', cost:40, itemType:'material', system:'standing_seam' },
      { sku:'7', uuid:'54-standing-seam-greencoat', name:'Standing Seam - Mechanical Lock 1.5 inch - Greencoat Pural BT', measurement:'TOTAL_PITCH_AREA', coverage:1, unit:'Each', cost:4.25, itemType:'material', system:'standing_seam' },
      { sku:'8', uuid:'58-starter-standing-seam', name:'Starter', measurement:'EAVES_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'9', uuid:'60-gable-standing-seam', name:'Gable', measurement:'RAKES_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'10', uuid:'61-ridge-cap-standing-seam', name:'Ridge Cap', measurement:'RIDGES_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'11', uuid:'64-valley-standing-seam', name:'Valley', measurement:'VALLEYS_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'12', uuid:'67-j-flashing-perforated', name:'J Flashing - Perforated', measurement:'RIDGES_LENGTH', coverage:5, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'13', uuid:'68-j-flashing-hips', name:'J Flashing - plain', measurement:'HIPS_LENGTH', coverage:5, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'14', uuid:'69-transition-flashing', name:'Transition Flashing', measurement:'TRANSITIONS_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'15', uuid:'70-wall-flashing', name:'Wall Flashing', measurement:'WALL_FLASHING_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'16', uuid:'71-j-flashing-other', name:'J Flashing - for other trim', measurement:'WALL_FLASHING_LENGTH,STEP_FLASHING_LENGTH,RAKES_LENGTH,TRANSITIONS_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'17', uuid:'72-step-flashing', name:'Step Flashing', measurement:'STEP_FLASHING_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'18', uuid:'75-screws-standing-seam', name:'Screws 250 EA (Flat head - Type A - 1 inch)', measurement:'TOTAL_PITCH_AREA', coverage:1, unit:'Each', cost:0, itemType:'material', system:'standing_seam' },
      { sku:'19', uuid:'76-clips-mechanical-lock', name:'Clips - Mechanical lock - 1000 pcs box', measurement:'TOTAL_PITCH_AREA', coverage:2, unit:'Each', cost:0, itemType:'material', system:'standing_seam', lockType:'mechanical' },
      { sku:'20', uuid:'76-clips-snap-lock', name:'Clips - Snap lock - 250 pcs box', measurement:'TOTAL_PITCH_AREA', coverage:2, unit:'Each', cost:0, itemType:'material', system:'standing_seam', lockType:'snap' },
      { sku:'21', uuid:'83-ht-underlayment', name:'Underlayment (Titanium PSU-30)', measurement:'TOTAL_PITCH_AREA', coverage:200, unit:'Roll', cost:135, itemType:'material', system:'standing_seam' },
      { sku:'22', uuid:'38-scope-metal-tiles', name:'Scope of Work - Metal Tiles', measurement:'TOTAL_PITCH_AREA', coverage:1, unit:'Square Foot', cost:6, itemType:'other', system:'metal_tiles' },
      { sku:'23', uuid:'56-metal-tiles', name:'Metal Tiles', measurement:'TOTAL_PITCH_AREA', coverage:24, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'24', uuid:'57-starter-tiles', name:'Starter - Tiles', measurement:'EAVES_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'25', uuid:'59-gable-tiles', name:'Gable - Tiles', measurement:'RAKES_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'26', uuid:'62-ridge-cap-long-tiles', name:'Ridge Cap Long (10 FT) - Tiles', measurement:'RIDGES_LENGTH,HIPS_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'27', uuid:'63-ridge-cap-short-tiles', name:'Ridge Cap Short - Tiles', measurement:'RIDGES_LENGTH,HIPS_LENGTH', coverage:6.5, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'28', uuid:'65-valley-tiles', name:'Valley - Tiles', measurement:'VALLEYS_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'29', uuid:'66-wall-flashing-tiles', name:'Wall Flashing - Tiles', measurement:'WALL_FLASHING_LENGTH,STEP_FLASHING_LENGTH', coverage:10, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'30', uuid:'74-screws-tiles', name:'Screws - Tiles', measurement:'TOTAL_PITCH_AREA', coverage:1, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'31', uuid:'82-synthetic-underlayment-tiles', name:'Synthetic underlayment - Tiles', measurement:'TOTAL_PITCH_AREA', coverage:640, unit:'EA', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'39', uuid:'39-metal-tile-membrane-auto', name:'Metal Tile Membrane', measurement:'TOTAL_PITCH_AREA', coverage:800, unit:'Roll', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'40', uuid:'40-multipurpose-closure-strip', name:'Multipurpose Closure Strip', measurement:'MULTIPURPOSE_CLOSURE', coverage:1, unit:'Strip', cost:1.95, itemType:'material', system:'metal_tiles' },
      { sku:'41', uuid:'41-snow-holder-2lf', name:'Snow Holder (2 LF)', measurement:'EAVES_LENGTH', coverage:4, unit:'Each', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'42', uuid:'42-ridge-vent-tape', name:'Ridge Vent Tape', measurement:'RIDGES_LENGTH', coverage:15, unit:'Roll', cost:0, itemType:'material', system:'metal_tiles' },
      { sku:'43', uuid:'43-vmax-tower-vent-black', name:'V-Max tower vent (black)', measurement:'VMAX_TOWER_VENT', coverage:1, unit:'Each', cost:135, itemType:'material', system:'metal_tiles' },
      { sku:'33', uuid:'33-titebond-metal-sealant-cartridge', name:'Titebond Metal Sealant Cartridge', measurement:'TOTAL_PITCH_AREA', coverage:300, unit:'Cartridge', cost:12.5, itemType:'material', system:'both' }
    ];

    /* Add real Shopify variant IDs here. Key = catalog UUID shown in table. */
    const SHOPIFY_VARIANTS = {};

    const SHOPIFY_PRODUCT_HANDLES_BY_UUID = {
      '54-standing-seam-greencoat': 'standing-seam-panels',
      '58-starter-standing-seam': 'starter-10ln-ft',
      '60-gable-standing-seam': 'gable-rake-10ln-ft',
      '61-ridge-cap-standing-seam': 'ridge-capping-10ln-ft',
      '64-valley-standing-seam': 'valleys-10ln-ft',
      '70-wall-flashing': 'wall-flashing-10ln-ft',
      '72-step-flashing': 'step-flashing-10ln-ft',
      '67-j-flashing-perforated': 'j-flashing-perforated-10ln-ft',
      '68-j-flashing-hips': 'j-flashing-plain-10ln-ft',
      'e7e26415-d47e-462d-b582-15f19b2e14b8': 'parapet-capping-10ln-ft',
      '75-screws-standing-seam': 'screws-250-ea',
      '76-clips-mechanical-lock': 'standing-seam-clips',
      '76-clips-snap-lock': 'standing-seam-clips',
      '83-ht-underlayment': 'titanium-psu-30-underlayment',
      '364688c1-8378-4934-ad42-1b9d5bc48e8f': 'drainage-mat-360-sf',
      '35-bathroom-metal-vent-auto': 'bathroom-metal-vent-1',
      '34-master-flashing-auto': 'master-flashing',
      '33-titebond-metal-sealant-cartridge': 'titebond-metal-sealant-cartridge',
    };

    const SHOPIFY_FIXED_SKU_BY_UUID = {
      '75-screws-standing-seam': 'SC250EA',
      '76-clips-mechanical-lock': 'CLME1000',
      '76-clips-snap-lock': 'CLSN250',
      '83-ht-underlayment': 'UNSI',
      '364688c1-8378-4934-ad42-1b9d5bc48e8f': 'DR360SF'
    };

    const SHOPIFY_FALLBACK_VARIANTS_BY_SKU = {
      "SSMSMPGL26GABL": {
            "variantId": "51837756440872",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPGL26GACH": {
            "variantId": "51837756473640",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPGL26GADA": {
            "variantId": "51837756506408",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPGL26GAWH": {
            "variantId": "51837756539176",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX26GABL": {
            "variantId": "51837756571944",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX26GACH": {
            "variantId": "51837756604712",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX26GADA": {
            "variantId": "51837756637480",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX26GAWH": {
            "variantId": "51837756670248",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX26GARR33": {
            "variantId": "51837756703016",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPGL24GABL": {
            "variantId": "51837756735784",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPGL24GACH": {
            "variantId": "51837756768552",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPGL24GADA": {
            "variantId": "51837756801320",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPGL24GAWH": {
            "variantId": "51837756834088",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX24GABL": {
            "variantId": "51837756866856",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX24GACH": {
            "variantId": "51837756899624",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX24GADA": {
            "variantId": "51837756932392",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMSMPTX24GAWH": {
            "variantId": "51837756965160",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPVDFGL24GABL": {
            "variantId": "51837756997928",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPVDFGL24GACH": {
            "variantId": "51837757030696",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPVDFGL24GADA": {
            "variantId": "51837757063464",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPVDFGL24GAWH": {
            "variantId": "51837757096232",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPURALST25GARR33": {
            "variantId": "51837757129000",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPURALST25GARR32": {
            "variantId": "51837757161768",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPURALST25GARR23": {
            "variantId": "51837757194536",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPURALST25GARR2H3": {
            "variantId": "51837757227304",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSMPURALST25GARR887": {
            "variantId": "51837757260072",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL26GABL": {
            "variantId": "51837757292840",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL26GACH": {
            "variantId": "51837757325608",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL26GADA": {
            "variantId": "51837757358376",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL26GAWH": {
            "variantId": "51837757391144",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX26GABL": {
            "variantId": "51837757587752",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX26GACH": {
            "variantId": "51837757620520",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX26GADA": {
            "variantId": "51837757653288",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX26GAWH": {
            "variantId": "51837757686056",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL24GABL": {
            "variantId": "51837757882664",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL24GACH": {
            "variantId": "51837757915432",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL24GADA": {
            "variantId": "51837757948200",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPGL24GAWH": {
            "variantId": "51837757980968",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX24GABL": {
            "variantId": "51837758177576",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX24GACH": {
            "variantId": "51837758210344",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX24GADA": {
            "variantId": "51837758243112",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSSMPTX24GAWH": {
            "variantId": "51837758275880",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPVDFGL24GABL": {
            "variantId": "51837758472488",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPVDFGL24GACH": {
            "variantId": "51837758505256",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPVDFGL24GADA": {
            "variantId": "51837758538024",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPVDFGL24GAWH": {
            "variantId": "51837758570792",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPURALST25GARR33": {
            "variantId": "51837758898472",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPURALST25GARR32": {
            "variantId": "51837758931240",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPURALST25GARR23": {
            "variantId": "51837758964008",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPURALST25GARR2H3": {
            "variantId": "51837758996776",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "SSSPURALST25GARR887": {
            "variantId": "51837759029544",
            "handle": "standing-seam-panels",
            "title": "Standing Seam Panels"
      },
      "ST10SMPGL26GABL": {
            "variantId": "51838159356200",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPGL26GACH": {
            "variantId": "51838164631848",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPGL26GADA": {
            "variantId": "51838164664616",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPGL26GAWH": {
            "variantId": "51838164697384",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX26GABL": {
            "variantId": "51838164730152",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX26GACH": {
            "variantId": "51838164762920",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX26GADA": {
            "variantId": "51838164795688",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX26GAWH": {
            "variantId": "51838164828456",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPGL24GABL": {
            "variantId": "51838164861224",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPGL24GACH": {
            "variantId": "51838164893992",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPGL24GADA": {
            "variantId": "51838164926760",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPGL24GAWH": {
            "variantId": "51838164959528",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX24GABL": {
            "variantId": "51838164992296",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX24GACH": {
            "variantId": "51838165025064",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX24GADA": {
            "variantId": "51838165057832",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10SMPTX24GAWH": {
            "variantId": "51838165090600",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PURALTX25GARR33": {
            "variantId": "51838172102952",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PURALTX25GARR32": {
            "variantId": "51838172135720",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PURALTX25GARR23": {
            "variantId": "51838172168488",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PURALTX25GARR2H3": {
            "variantId": "51838172201256",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PURALTX25GARR887": {
            "variantId": "51838172234024",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PVDFGL24GABL": {
            "variantId": "51838184587560",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PVDFGL24GACH": {
            "variantId": "51838184620328",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PVDFGL24GADA": {
            "variantId": "51838184653096",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "ST10PVDFGL24GAWH": {
            "variantId": "51838184685864",
            "handle": "starter-10ln-ft",
            "title": "Starter - 10ln. ft."
      },
      "CLME1000": {
            "variantId": "51838159716648",
            "handle": "standing-seam-clips",
            "title": "Standing Seam Clips"
      },
      "SC250EA": {
            "variantId": "51838159749416",
            "handle": "screws-250-ea",
            "title": "Screws 250 EA"
      },
      "UNSI": {
            "variantId": "51838159782184",
            "handle": "titanium-psu-30-underlayment",
            "title": "Titanium PSU-30 Underlayment"
      },
      "DR360SF": {
            "variantId": "51838159847720",
            "handle": "drainage-mat-360-sf",
            "title": "Drainage Mat 360 SF"
      },
      "GA10SMPGL26GACH": {
            "variantId": "51838198219048",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPGL26GADA": {
            "variantId": "51838198251816",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPGL26GAWH": {
            "variantId": "51838198284584",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX26GABL": {
            "variantId": "51838198317352",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX26GACH": {
            "variantId": "51838198350120",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX26GADA": {
            "variantId": "51838198382888",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX26GAWH": {
            "variantId": "51838198415656",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PURALST25GARR33": {
            "variantId": "51838198448424",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PURALST25GARR32": {
            "variantId": "51838198481192",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPGL24GABL": {
            "variantId": "51838198513960",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PURALST25GARR23": {
            "variantId": "51838198546728",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPGL24GACH": {
            "variantId": "51838198579496",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PURALST25GARR2H3": {
            "variantId": "51838198612264",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPGL24GADA": {
            "variantId": "51838198645032",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PURALST25GARR887": {
            "variantId": "51838198677800",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPGL24GAWH": {
            "variantId": "51838198710568",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PVDFGL24GABL": {
            "variantId": "51838198743336",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PVDFGL24GACH": {
            "variantId": "51838198776104",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PVDFGL24GADA": {
            "variantId": "51838198808872",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10PVDFGL24GAWH": {
            "variantId": "51838198841640",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX24GABL": {
            "variantId": "51838198874408",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX24GACH": {
            "variantId": "51838198907176",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX24GADA": {
            "variantId": "51838198939944",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "GA10SMPTX24GAWH": {
            "variantId": "51838198972712",
            "handle": "gable-rake-10ln-ft",
            "title": "Gable (Rake) - 10ln. ft."
      },
      "RI10SMPGL26GACH": {
            "variantId": "51838199038248",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPGL26GADA": {
            "variantId": "51838199071016",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPGL26GAWH": {
            "variantId": "51838199103784",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX26GABL": {
            "variantId": "51838199136552",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX26GACH": {
            "variantId": "51838199169320",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX26GADA": {
            "variantId": "51838199202088",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX26GAWH": {
            "variantId": "51838199234856",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PURALST25GARR33": {
            "variantId": "51838199267624",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PURALST25GARR32": {
            "variantId": "51838199300392",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPGL24GABL": {
            "variantId": "51838199333160",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PURALST25GARR23": {
            "variantId": "51838199365928",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPGL24GACH": {
            "variantId": "51838199398696",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PURALST25GARR2H3": {
            "variantId": "51838199431464",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPGL24GADA": {
            "variantId": "51838199464232",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PURALST25GARR887": {
            "variantId": "51838199497000",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPGL24GAWH": {
            "variantId": "51838199529768",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PVDFGL24GABL": {
            "variantId": "51838199562536",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PVDFGL24GACH": {
            "variantId": "51838199595304",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PVDFGL24GADA": {
            "variantId": "51838199628072",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10PVDFGL24GAWH": {
            "variantId": "51838199660840",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX24GABL": {
            "variantId": "51838199693608",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX24GACH": {
            "variantId": "51838199726376",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX24GADA": {
            "variantId": "51838199759144",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "RI10SMPTX24GAWH": {
            "variantId": "51838199791912",
            "handle": "ridge-capping-10ln-ft",
            "title": "Ridge Capping - 10ln. ft."
      },
      "VA10SMPGL26GACH": {
            "variantId": "51838199857448",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPGL26GADA": {
            "variantId": "51838199890216",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPGL26GAWH": {
            "variantId": "51838199922984",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX26GABL": {
            "variantId": "51838199955752",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX26GACH": {
            "variantId": "51838199988520",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX26GADA": {
            "variantId": "51838200021288",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX26GAWH": {
            "variantId": "51838200054056",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PURALST25GARR33": {
            "variantId": "51838200086824",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PURALST25GARR32": {
            "variantId": "51838200119592",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPGL24GABL": {
            "variantId": "51838200152360",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PURALST25GARR23": {
            "variantId": "51838200185128",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPGL24GACH": {
            "variantId": "51838200217896",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PURALST25GARR2H3": {
            "variantId": "51838200250664",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPGL24GADA": {
            "variantId": "51838200283432",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PURALST25GARR887": {
            "variantId": "51838200316200",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPGL24GAWH": {
            "variantId": "51838200348968",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PVDFGL24GABL": {
            "variantId": "51838200381736",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PVDFGL24GACH": {
            "variantId": "51838200414504",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PVDFGL24GADA": {
            "variantId": "51838200447272",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10PVDFGL24GAWH": {
            "variantId": "51838200480040",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX24GABL": {
            "variantId": "51838200512808",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX24GACH": {
            "variantId": "51838200545576",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX24GADA": {
            "variantId": "51838200578344",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "VA10SMPTX24GAWH": {
            "variantId": "51838200611112",
            "handle": "valleys-10ln-ft",
            "title": "Valleys - 10ln. ft."
      },
      "WA10SMPGL26GACH": {
            "variantId": "51838200676648",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPGL26GADA": {
            "variantId": "51838200709416",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPGL26GAWH": {
            "variantId": "51838200742184",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX26GABL": {
            "variantId": "51838200774952",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX26GACH": {
            "variantId": "51838200807720",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX26GADA": {
            "variantId": "51838200840488",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX26GAWH": {
            "variantId": "51838200873256",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PURALST25GARR33": {
            "variantId": "51838200906024",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PURALST25GARR32": {
            "variantId": "51838200938792",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPGL24GABL": {
            "variantId": "51838200971560",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PURALST25GARR23": {
            "variantId": "51838201004328",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPGL24GACH": {
            "variantId": "51838201037096",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PURALST25GARR2H3": {
            "variantId": "51838201069864",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPGL24GADA": {
            "variantId": "51838201102632",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PURALST25GARR887": {
            "variantId": "51838201135400",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPGL24GAWH": {
            "variantId": "51838201168168",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PVDFGL24GABL": {
            "variantId": "51838201200936",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PVDFGL24GACH": {
            "variantId": "51838201233704",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PVDFGL24GADA": {
            "variantId": "51838201266472",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10PVDFGL24GAWH": {
            "variantId": "51838201299240",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX24GABL": {
            "variantId": "51838201332008",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX24GACH": {
            "variantId": "51838201364776",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX24GADA": {
            "variantId": "51838201397544",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "WA10SMPTX24GAWH": {
            "variantId": "51838201430312",
            "handle": "wall-flashing-10ln-ft",
            "title": "Wall Flashing - 10ln. ft."
      },
      "SF10SMPGL26GACH": {
            "variantId": "51838201495848",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPGL26GADA": {
            "variantId": "51838201528616",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPGL26GAWH": {
            "variantId": "51838201561384",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX26GABL": {
            "variantId": "51838201594152",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX26GACH": {
            "variantId": "51838201626920",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX26GADA": {
            "variantId": "51838201659688",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX26GAWH": {
            "variantId": "51838201692456",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PURALST25GARR33": {
            "variantId": "51838201725224",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PURALST25GARR32": {
            "variantId": "51838201757992",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPGL24GABL": {
            "variantId": "51838201790760",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PURALST25GARR23": {
            "variantId": "51838201823528",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPGL24GACH": {
            "variantId": "51838201856296",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PURALST25GARR2H3": {
            "variantId": "51838201889064",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPGL24GADA": {
            "variantId": "51838201921832",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PURALST25GARR887": {
            "variantId": "51838201954600",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPGL24GAWH": {
            "variantId": "51838201987368",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PVDFGL24GABL": {
            "variantId": "51838202020136",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PVDFGL24GACH": {
            "variantId": "51838202052904",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PVDFGL24GADA": {
            "variantId": "51838202085672",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10PVDFGL24GAWH": {
            "variantId": "51838202118440",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX24GABL": {
            "variantId": "51838202151208",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX24GACH": {
            "variantId": "51838202183976",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX24GADA": {
            "variantId": "51838202216744",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "SF10SMPTX24GAWH": {
            "variantId": "51838202249512",
            "handle": "step-flashing-10ln-ft",
            "title": "Step Flashing - 10ln. ft."
      },
      "JFP10SMPGL26GACH": {
            "variantId": "51838202315048",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPGL26GADA": {
            "variantId": "51838202347816",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPGL26GAWH": {
            "variantId": "51838202380584",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX26GABL": {
            "variantId": "51838202413352",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX26GACH": {
            "variantId": "51838202446120",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX26GADA": {
            "variantId": "51838202478888",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX26GAWH": {
            "variantId": "51838202511656",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PURALST25GARR33": {
            "variantId": "51838202544424",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PURALST25GARR32": {
            "variantId": "51838202577192",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPGL24GABL": {
            "variantId": "51838202609960",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PURALST25GARR23": {
            "variantId": "51838202642728",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPGL24GACH": {
            "variantId": "51838202675496",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PURALST25GARR2H3": {
            "variantId": "51838202708264",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPGL24GADA": {
            "variantId": "51838202741032",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PURALST25GARR887": {
            "variantId": "51838202773800",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPGL24GAWH": {
            "variantId": "51838202806568",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PVDFGL24GABL": {
            "variantId": "51838202839336",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PVDFGL24GACH": {
            "variantId": "51838202872104",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PVDFGL24GADA": {
            "variantId": "51838202904872",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10PVDFGL24GAWH": {
            "variantId": "51838202937640",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX24GABL": {
            "variantId": "51838202970408",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX24GACH": {
            "variantId": "51838203003176",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX24GADA": {
            "variantId": "51838203035944",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFP10SMPTX24GAWH": {
            "variantId": "51838203068712",
            "handle": "j-flashing-perforated-10ln-ft",
            "title": "J Flashing - Perforated - 10ln. ft."
      },
      "JFL10SMPGL26GACH": {
            "variantId": "51838203134248",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPGL26GADA": {
            "variantId": "51838203167016",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPGL26GAWH": {
            "variantId": "51838203199784",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX26GABL": {
            "variantId": "51838203232552",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX26GACH": {
            "variantId": "51838203265320",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX26GADA": {
            "variantId": "51838203298088",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX26GAWH": {
            "variantId": "51838203330856",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PURALST25GARR33": {
            "variantId": "51838203363624",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PURALST25GARR32": {
            "variantId": "51838203396392",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPGL24GABL": {
            "variantId": "51838203429160",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PURALST25GARR23": {
            "variantId": "51838203461928",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPGL24GACH": {
            "variantId": "51838203494696",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PURALST25GARR2H3": {
            "variantId": "51838203527464",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPGL24GADA": {
            "variantId": "51838203560232",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PURALST25GARR887": {
            "variantId": "51838203593000",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPGL24GAWH": {
            "variantId": "51838203625768",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PVDFGL24GABL": {
            "variantId": "51838203658536",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PVDFGL24GACH": {
            "variantId": "51838203691304",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PVDFGL24GADA": {
            "variantId": "51838203724072",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10PVDFGL24GAWH": {
            "variantId": "51838203756840",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX24GABL": {
            "variantId": "51838203789608",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX24GACH": {
            "variantId": "51838203822376",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX24GADA": {
            "variantId": "51838203855144",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "JFL10SMPTX24GAWH": {
            "variantId": "51838203887912",
            "handle": "j-flashing-plain-10ln-ft",
            "title": "J Flashing - Plain - 10ln. ft."
      },
      "PA10SMPGL26GACH": {
            "variantId": "51838203953448",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPGL26GADA": {
            "variantId": "51838203986216",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPGL26GAWH": {
            "variantId": "51838204018984",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX26GABL": {
            "variantId": "51838204051752",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX26GACH": {
            "variantId": "51838204084520",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX26GADA": {
            "variantId": "51838204117288",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX26GAWH": {
            "variantId": "51838204150056",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PURALST25GARR33": {
            "variantId": "51838204182824",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PURALST25GARR32": {
            "variantId": "51838204215592",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPGL24GABL": {
            "variantId": "51838204248360",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PURALST25GARR23": {
            "variantId": "51838204281128",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPGL24GACH": {
            "variantId": "51838204313896",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PURALST25GARR2H3": {
            "variantId": "51838204346664",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPGL24GADA": {
            "variantId": "51838204379432",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PURALST25GARR887": {
            "variantId": "51838204412200",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPGL24GAWH": {
            "variantId": "51838204444968",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PVDFGL24GABL": {
            "variantId": "51838204477736",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PVDFGL24GACH": {
            "variantId": "51838204510504",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PVDFGL24GADA": {
            "variantId": "51838204543272",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10PVDFGL24GAWH": {
            "variantId": "51838204576040",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX24GABL": {
            "variantId": "51838204608808",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX24GACH": {
            "variantId": "51838204641576",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX24GADA": {
            "variantId": "51838204674344",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      },
      "PA10SMPTX24GAWH": {
            "variantId": "51838204707112",
            "handle": "parapet-capping-10ln-ft",
            "title": "Parapet Capping - 10ln. ft."
      }
};

